import { ActionBarPrimitive } from '@assistant-ui/react';
import { IconPencil } from '@tabler/icons-react';

import { TooltipIconButton } from '../tooltip-icon-button/TooltipIconButton.tsx';

/** Action bar for user messages providing edit functionality. */
export function UserActionBar() {
  return (
    <ActionBarPrimitive.Root
      autohide="not-last" // Prevent editing historical messages to maintain conversation coherence
      hideWhenRunning // Prevent edits during generation to avoid race conditions
    >
      <ActionBarPrimitive.Edit asChild>
        <TooltipIconButton position="left" tooltip="Edit">
          <IconPencil />
        </TooltipIconButton>
      </ActionBarPrimitive.Edit>
    </ActionBarPrimitive.Root>
  );
}
